export default "__VITE_ASSET__JDKOddD___"